import { render, staticRenderFns } from "./ListaTraspasosPorEstatus.vue?vue&type=template&id=6db81afc"
import script from "./ListaTraspasosPorEstatus.vue?vue&type=script&lang=js"
export * from "./ListaTraspasosPorEstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports